"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPresetTypes = {
    dealer: 1,
    common: 2,
    user: 3,
    tag: 4
};
